import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTicket: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTicket"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V9.82285L21.4473 9.97357C19.4342 10.5226 19.4342 13.4774 21.4473 14.0264L22 14.1772V20H2V14.1772L2.55266 14.0264C4.56578 13.4774 4.56578 10.5226 2.55266 9.97357L2 9.82285V4ZM16 7V9H14.5V7H16ZM16 11V13H14.5V11H16ZM16 15V17H14.5V15H16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTicket;
